// this file is meant to be shared by both the vue app and proteus app

let _vueapp;
let _store;

export const setVueApp = vueapp => (_vueapp = vueapp);

export const getVueApp = () => _vueapp;

export const setStore = store => (_store = store);

export const getStore = () => _store;

export const getCurrentUser = () => {
  if (!_store) throw new Error("Store is not initialized properly.");

  return _store.state.user.currentUser;
};
